export { DetailedLanding } from './DetailedLanding';
